<div class="reading-room-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  <div class="heading-wrapper">
    <h4>{{ 'pages.tooltips.listTitle' | translate }}</h4>
  </div>
  <app-table
    [columns]="tableColumns"
    [endpoint]="apiPath"
    [withPagination]="true"
    [withSearch]="false"
    [sortBy]="'code'"
    [flatTopBorder]="true"
    viewEntryPath="/uznirstosie-portala-padomi/rediget/{id}"
    editEntryPath="/uznirstosie-portala-padomi/rediget/{id}" />
</div>
